import createClient from '../../plugins/gatsby-source-bs-shopify/create-client'

const shopName = process.env.GATSBY_SHOPIFY_SHOP_NAME
const accessToken = process.env.GATSBY_SHOPIFY_SF_ACCESS_TOKEN

export const client = createClient(shopName, accessToken)
